module.exports = __webpack_public_path__ + "static/img/41.4affb8bf.png";